import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {TranslatorService} from '../../../../translation/translator.service';
import {Notification} from '../../../state/notification';
import {AccountDataQuery} from '../../../../account/account-data-query';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AccountDataFunctions} from '../../../../account/account-data';
import {Id37Router} from '../../../../id37-router';

@Component({
  selector: 'app-test-finished-message',
  templateUrl: './test-finished-message.component.html',
  styleUrls: ['./test-finished-message.component.scss']
})
export class TestFinishedMessageComponent implements OnInit, OnDestroy {

  @Input()
    notification: Notification;

  private unsubscribe$: Subject<void> = new Subject<void>();

  userId: string = '...';
  userName: string = '...';
  messagePartA: string = '';
  messagePartB: string = '';
  messagePartC: string = '';
  report: string = '';

  constructor(private accountDataQuery: AccountDataQuery,
              private translatorService: TranslatorService,
              private id37Router: Id37Router) {
  }

  ngOnInit(): void {
    this.computeMessage();
    this.accountDataQuery.selectAccountData(this.notification.data.userId as string)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(accountData => this.userName = AccountDataFunctions.fullName(accountData));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  goToCustomers(): void {
    this.id37Router.routeToCustomers(this.notification.data.userId as string, this.notification.data.testId as string);
  }

  goToProfile(): void {
    this.id37Router.routeToReport(this.notification.data.userId as string, this.notification.data.testId as string);
  }

  computeMessage(): void {
    this.messagePartA = this.__('partA');
    this.messagePartB = this.__('partB');
    this.messagePartC = this.__('partC');
    this.report = this.__('report');
  }

  __(key: string): string {
    return this.translatorService.translate('notification.' + this.notification.type + '.message.' + key);
  }

}
